import Surrounding1 from '../Surrounding/Surrounding (11).webp'
import Surrounding2 from '../Surrounding/Surrounding (2).webp'
import Surrounding3 from '../Surrounding/Surrounding (3).webp'
import Surrounding4 from '../Surrounding/Surrounding (4).webp'
import Surrounding5 from '../Surrounding/Surrounding (5).webp'
import Surrounding6 from '../Surrounding/Surrounding (6).webp'
import Surrounding7 from '../Surrounding/Surrounding (7).webp'
import Surrounding8 from '../Surrounding/Surrounding (8).webp'
import Surrounding9 from '../Surrounding/Surrounding (9).webp'
import Surrounding10 from '../Surrounding/Surrounding (10).webp'
import Surrounding11 from '../Surrounding/Surrounding (1).webp'
import Surrounding12 from '../Surrounding/Surrounding (12).webp'

const Surroundingimages =[
Surrounding1,Surrounding2,Surrounding3,Surrounding4,Surrounding5,Surrounding6,Surrounding7,Surrounding8,Surrounding9,Surrounding10,Surrounding11,Surrounding12
]

export default Surroundingimages;